export function getDisplayCategory(categories = []) {
  return categories.find((category) => category.slug !== "uncategorized");
}

export function getStockStatusLabel(stockStatus, t) {
  switch (stockStatus) {
    case "instock":
      return t("In stock");
    case "outofstock":
      return t("Out of stock");
    case "onbackorder":
      return t("On backorder");
    default:
      return stockStatus;
  }
}
